"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = exports.StyledGroupCheckboxContainer = exports.StyledFieldSet = exports.StyledCheckbox = exports.LabelTypography = exports.LabelToolTip = exports.HiddenCheckbox = exports.CheckboxWrapper = exports.CheckboxContainer = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledSystem = require("styled-system");
var _ = require("..");
var _constant = require("../../styles/constant");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
const styledCheckboxFit = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      width: '16px',
      height: '16px',
      borderRadius: '3px'
    },
    medium: {
      width: '20px',
      height: '20px',
      borderRadius: '4px'
    },
    large: {
      width: '24px',
      height: '24px',
      borderRadius: '4px'
    }
  }
});
const variants = {
  styledCheckboxFit
};
const CheckboxContainer = exports.CheckboxContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  input[type='checkbox' i]:focus-visible {\n    outline: 0 !important;\n  }\n"])));
/* Input field type checkbox for custom checkbox */
const HiddenCheckbox = exports.HiddenCheckbox = _styledComponents["default"].input.withConfig({
  shouldForwardProp: prop => !['value'].includes(prop)
}).attrs({
  type: 'checkbox'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  border: ", ";\n  margin: ", ";\n  overflow: hidden;\n  padding: ", ";\n  position: absolute;\n  white-space: nowrap;\n  visibility: hidden;\n"])), (0, _constant.get)('space.0'), (0, _constant.get)('space.-1'), (0, _constant.get)('space.0'));
const StyledLabel = exports.StyledLabel = _styledComponents["default"].label(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  user-select: none;\n  cursor: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n"])), _ref => {
  let {
    disabled
  } = _ref;
  return disabled ? 'not-allowed' : 'pointer';
});
const CheckboxWrapper = exports.CheckboxWrapper = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n"])));
const LabelToolTip = exports.LabelToolTip = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n"])), (0, _constant.get)('space.4'));
const getDynamicStyleCheckbox = _ref2 => {
  let {
    error,
    checked,
    disabled
  } = _ref2;
  let background = (0, _constant.get)('colors.functional.grey.50');
  let hoverBackground = null;
  let border = (0, _constant.get)('colors.functional.grey.400');
  let boxShadow = (0, _constant.get)('boxShadows.type.basic.default');
  let borderColor = !disabled && (0, _constant.get)('colors.primary.blue.400');
  let cursor = 'pointer';
  if (disabled) {
    cursor = 'not-allowed';
    if (checked) {
      background = hoverBackground = (0, _constant.get)('colors.functional.grey.400');
    } else {
      background = hoverBackground = (0, _constant.get)('colors.functional.grey.100');
      border = (0, _constant.get)('colors.functional.grey.300');
    }
  } else if (error && checked) {
    const dangerColor = (0, _constant.get)('colors.feedback.danger.normal');
    background = border = hoverBackground = dangerColor;
    boxShadow = borderColor = (0, _constant.get)('boxShadows.type.basic.danger');
  } else if (error && !checked) {
    const dangerColor = (0, _constant.get)('colors.feedback.danger.normal');
    border = dangerColor;
    boxShadow = borderColor = (0, _constant.get)('colors.feedback.danger.light');
    hoverBackground = 'transparent';
  } else if (checked) {
    background = 'rgb(0,61,109)';
    border = 'transparent';
  } else {
    background = (0, _constant.get)('colors.functional.grey.50');
    borderColor = (0, _constant.get)('colors.functional.grey.600');
  }
  return (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    background-color: ", ";\n    /* Todo: as theme 1px */\n    border: 1px solid ", ";\n    cursor: ", ";\n    &:hover,\n    ", ":hover & {\n      background: ", ";\n      border-color: ", ";\n    }\n    ", ":focus-within + &&& {\n      /* Todo: how to handle dynamic box-shadow? */\n      box-shadow: ", ";\n      border-color: ", ";\n    }\n  "])), background, border, cursor, StyledLabel, hoverBackground, borderColor, HiddenCheckbox, boxShadow, borderColor);
};
const StyledCheckbox = exports.StyledCheckbox = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  box-sizing: border-box;\n  transition: all 150ms;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & svg {\n    visibility: ", ";\n    & path {\n      stroke: ", ";\n    }\n  }\n  &::disabled {\n    cursor: not-allowed;\n  }\n  &:focus {\n    outline: 0px;\n    border-color: rgb(66, 176, 213);\n    box-shadow: rgb(181, 224, 245) 0px 0px 0px 3px;\n  }\n"])), variants.styledCheckboxFit, props => getDynamicStyleCheckbox(props), props => props.checked ? 'visible' : 'hidden', (0, _constant.get)('colors.functional.grey.50'));
const LabelTypography = exports.LabelTypography = (0, _styledComponents["default"])(_.Typography)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  margin-left: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  & span.required {\n    &:after {\n      content: ' *';\n      color: ", ";\n    }\n  }\n"])), (0, _constant.get)('space.8'), props => props.fit === 'small' ? (0, _constant.get)('fontSizes.14') : (0, _constant.get)('fontSizes.16'), props => props.fit === 'small' ? (0, _constant.get)('space.20') : (0, _constant.get)('space.24'), (0, _constant.get)('colors.functional.grey.900'), (0, _constant.get)('colors.feedback.danger.normal'));
const StyledFieldSet = exports.StyledFieldSet = _styledComponents["default"].fieldset(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", ";\n  border: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  display: flex;\n  flex-direction: column;\n  > ", " {\n    margin: ", ";\n  }\n"])), (0, _constant.get)('space.0'), (0, _constant.get)('space.0'), (0, _constant.get)('space.0'), (0, _constant.get)('space.4'), LabelTypography, (0, _constant.get)('space.0'));
const customOrientation = (0, _styledSystem.variant)({
  prop: 'orientation',
  variants: {
    horizontal: {
      '> *': {
        paddingRight: (0, _constant.get)('space.20')
      }
    },
    vertical: {
      '> *': {
        paddingRight: (0, _constant.get)('space.0'),
        marginBottom: (0, _constant.get)('space.6')
      }
    }
  }
});
const StyledGroupCheckboxContainer = exports.StyledGroupCheckboxContainer = (0, _styledComponents["default"])(_.Box)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: ", ";\n  ", ";\n"])), props => props.fit === 'small' ? (0, _constant.get)('space.8') : props.fit === 'medium' ? (0, _constant.get)('space.12') : (0, _constant.get)('space.16'), customOrientation);